module.exports = __webpack_public_path__ + "static/media/ada.b305413e.png";